const colorSelector = {
	Leads: 'LIGHT_BLUE',
	Contacts: 'LIGHT_GREEN',
	Accounts: 'LIGHT_RED'
}

export default colorSelector
